import { AxiosError } from "axios";
import qs from "query-string";
import { useQuery } from "react-query";
import { PastExecutionsResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const usePastExecutions = (
  pageTable: number,
  resultsPerPage: number = 20,
  searchTerm?: string,
  usernameSearch?: string
) => {
  const newSkip = (pageTable - 1) * resultsPerPage;
  return useQuery<any, AxiosError<any>, PastExecutionsResponse>(
    ["executions", "past", pageTable],
    async () => {
      const query: Record<string, any> = {
        skip: newSkip,
        limit: resultsPerPage,
        searchTerm,
        usernameSearch,
      };
      if (!searchTerm) {
        delete query.searchTerm;
      }
      if (!usernameSearch) {
        delete query.usernameSearch;
      }

      const data = await axiosClient.get<PastExecutionsResponse>(
        `/execution/getAll/past?${qs.stringify(query)}`
      );
      return data.data;
    },
    {
      staleTime: Infinity,
      keepPreviousData: true,
      enabled: false,
    }
  );
};
